import React from "react";
import { useHistory } from "react-router-dom";

import { Grid, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Button from "../../components/Button";
import logo from "../../assets/images/logo.svg";
import success from "../../assets/images/success.png";
import Logo from "../../components/Logo";
import Paper from "../../components/Paper";
import Background from "../../components/Background";
import Disclaimer from "../../components/Disclaimer";
import MetaDecorator from "../../components/MetaDecorator";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    img: {
      width: "6rem",
      margin: theme.spacing(4, 0),
    },
  })
);

export default function PasswordUpdated() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <MetaDecorator />
      <Background>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={8} lg={3}>
            <Paper>
              <Logo src={logo} />
              <img src={success} alt="" className={classes.img} />
              <Typography variant="h4">
                Lozinka je uspješno promijenjena.
              </Typography>
              <Disclaimer>
                Uspješno ste promijenili lozinku. Kliknite na gumb "Prijavi se"
                kako biste se ponovno prijavili i upišite svoju novu lozinku.
              </Disclaimer>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                onClick={() => history.push("/prijava")}
              >
                Prijavi se
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Background>
    </>
  );
}
